import React, { Fragment } from "react";
import Moment from "react-moment";
import { Box } from "@mui/material";
import { SectionHeading, LabelText, ValueText } from "../Common/Typography/AppTypography";
import Grid2 from "@mui/material/Grid2";

const FirmwareDetails = ({ firmwareData, deviceID, showHeader = true }) => {
  return (
    <Fragment>
      {firmwareData?.length > 0 ? (
        <Box>
          <Box sx={{ textAlign: "center", py: 3 }}>
            {showHeader && (
              <SectionHeading sx={{ mb: 0 }}>
                Device Firmware Upgrade History
              </SectionHeading>
            )}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexWrap: "wrap",
                gap: 2,
                py: 2,
                bgcolor: "rgba(0,0,0,0.04)",
                borderRadius: 1,
                my: 2,
              }}
            >
              <Box sx={{ display: "inline-flex", pr: 2.5 }}>
                <LabelText sx={{ mr: 1 }}>Device ID :</LabelText>
                <ValueText>{deviceID}</ValueText>
              </Box>
              <Box sx={{ display: "inline-flex", pl: 2.5 }}>
                <LabelText sx={{ mr: 1 }}>Model Number :</LabelText>
                <ValueText>{firmwareData[0]?.modelNumber}</ValueText>
              </Box>
            </Box>
          </Box>

          <Box sx={{ px: 3, pb: 3 }}>
            <Grid2 container sx={{ borderBottom: "1px solid rgba(0,0,0,0.12)", py: 1.5 }}>
              <Grid2 size={4}>
                <LabelText strong>Firmware Version</LabelText>
              </Grid2>
              <Grid2 size={4}>
                <LabelText strong>Download Date</LabelText>
              </Grid2>
              <Grid2 size={4}>
                <LabelText strong>Device Status</LabelText>
              </Grid2>
            </Grid2>
            {firmwareData.map((firmwareInfo, i) => (
              <Grid2 container key={i} sx={{ py: 1.5, borderBottom: "1px solid rgba(0,0,0,0.08)" }}>
                <Grid2 size={4}>
                  <Box sx={{ p: 1.5, bgcolor: "rgba(0,0,0,0.02)", borderRadius: 1 }}>
                    <ValueText>{firmwareInfo.firmwareVersion}</ValueText>
                  </Box>
                </Grid2>
                <Grid2 size={4}>
                  <Box sx={{ p: 1.5, bgcolor: "rgba(0,0,0,0.02)", borderRadius: 1 }}>
                    <ValueText>
                      <Moment format="MMMM Do, YYYY" date={firmwareInfo.downloadDate} />
                    </ValueText>
                  </Box>
                </Grid2>
                <Grid2 size={4}>
                  <Box sx={{ p: 1.5, bgcolor: "rgba(0,0,0,0.02)", borderRadius: 1 }}>
                    <ValueText>{firmwareInfo.deviceStatus}</ValueText>
                  </Box>
                </Grid2>
              </Grid2>
            ))}
          </Box>
        </Box>
      ) : (
        <Box>
          {showHeader && (
            <Box sx={{ textAlign: "center", py: 3 }}>
              <SectionHeading sx={{ mb: 0 }}>
                Device Firmware Upgrade History
              </SectionHeading>
            </Box>
          )}
          <Box sx={{ p: 2 }}>
            <Box
              sx={{
                p: 2,
                bgcolor: "rgba(211, 47, 47, 0.08)",
                borderRadius: 1,
                border: "1px solid rgba(211, 47, 47, 0.3)",
              }}
            >
              <LabelText sx={{ color: "error.main" }}>
                {(firmwareData && firmwareData.msg) && firmwareData.msg}
              </LabelText>
            </Box>
          </Box>
        </Box>
      )}
    </Fragment>
  );
};

export default FirmwareDetails;
 